import { styled } from "@ff/ui";
import Box from "@ff/ui/Box";

export default styled(Box)(({theme}) => ({
  paddingLeft: '20px',
  paddingRight: '20px',

  [theme.mediaQueries.md]: {
    paddingLeft: '48px',
    paddingRight: '48px',
  }
}));

